import React from 'react';

const Input = ({ type, label, placeholder, value, onChange,name, required }) => {
  return (
    <div className="input-wrapper">
      {label && <label htmlFor={label}>{label}</label>}
      <input
        type={type}
        id={label}
        required={required ? required : ''}
        name={name}
        autoComplete="off"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default Input;
